import { PartnerRemoveWizard } from '@features/ForestOwner/EditShareOwnership/Partner/PartnerRemoveWizard'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate/useTranslations'

export const Route = createFileRoute(
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/remove/',
)({
  component: () => <PartnerRemoveWizard />,
  staticData: {
    breadcrumb: t('forestowner-editshareownership-partner.removeBreadcrumb'),
  },
})
